import React from 'react';

const InputTitleView = ({ title, required, subTitle }) => {
  return (
    <div className="recruitment-input-view-title-wrapper">
      <div>
        <span className="recruitment-input-view-title">{title}</span>
        {required && <span className="recruitment-input-view-required">*</span>}
      </div>
      <div className="recruitment-input-view-sub-title">{subTitle}</div>
    </div>
  );
};

export default InputTitleView;
